import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from "react-router-dom";

import './index.scss';

// Routes
import Route404 from './routes/Route404';
import RouteRoot from './routes/RouteRoot';
import RouteAbout from './routes/RouteAbout';
import RouteTools from './routes/RouteTools';
import RouteToolsBoxShadow from './routes/RouteToolsBoxShadow';
import RouteToolsBorderRadius from './routes/RouteToolsBorderRadius';
import RouteToolsTextShadow from './routes/RouteToolsTextShadow';
import RouteToolsFilter from './routes/RouteToolsFilter';
import RouteToolsColorPicker from './routes/RouteToolsColorPicker';
import RouteToolsEncoderURL from './routes/RouteToolsEncoderURL';
import RouteToolsEncoderBase64 from './routes/RouteToolsEncoderBase64';
import RouteToolsImageCrop from './routes/RouteToolsImageCrop';
import RouteLinks from './routes/RouteLinks';

// Translations
import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';
import common_en from "./translations/en_common.json";
import common_es from "./translations/es_common.json";
import getLanguage from './utils/language/getLanguage';

i18next.init((() =>
{
    // Return initial optiones
    return {
        lng: getLanguage(),
        interpolation: { escapeValue: false },  // React already does escaping
        resources: {
            en: { common: common_en },
            es: { common: common_es },
        },
    };
})());

ReactDOM.render(
<>
    <I18nextProvider i18n={i18next}>
        <BrowserRouter>
            <Switch>
                <Route exact path="/" component={RouteRoot} />
                <Route exact path="/about" component={RouteAbout} />
                <Route exact path="/tools" component={RouteTools} />
                <Route exact path="/links" component={RouteLinks} />
                <Route exact path="/tools/box-shadow" component={RouteToolsBoxShadow} />
                <Route exact path="/tools/border-radius" component={RouteToolsBorderRadius} />
                <Route exact path="/tools/text-shadow" component={RouteToolsTextShadow} />
                <Route exact path="/tools/filter" component={RouteToolsFilter} />
                <Route exact path="/tools/color-picker" component={RouteToolsColorPicker} />
                <Route exact path="/tools/url-encoder" component={RouteToolsEncoderURL} />
                <Route exact path="/tools/base64-encoder" component={RouteToolsEncoderBase64} />
                <Route exact path="/tools/image-crop" component={RouteToolsImageCrop} />

                <Route component={Route404} />
            </Switch>
        </BrowserRouter>
    </I18nextProvider>
</>,
document.getElementById("root"));
